export const EVENT_APPRAISER_ASSIGNMENT_ROLE = {
  NA: 0,
  PRIMARY: 1,
  SECONDARY: 2
};
